<template>
    <div class="search" :style="styleData" :class="{'is-focus': isFocus}">
        <div class="input-wrapper">
            <input type="text"
                @input="limitInput($data, 'value')"
                @focus="isFocus = true"
                @blur="isFocus = false"
                @keyup.enter="searchData('keywords')"
                :placeholder="styleData.placeholder"
                :maxlength="maxlength"
                v-model="value">
        </div>
        <i @click="clear" v-show="value" class="el-icon el-icon-close"></i>
        <span @click="searchData('keywords')">
            搜索
        </span>
    </div>
</template>
<script>
import { inputLimit, inputSpaceLimitReg } from '@/utils'
export default {
    data() {
        return {
            value: '',
            isFocus: false
        }
    },
    props: {
        styleData: {
            default: () => ({
                placeholder: '请输入'
            }),
            type: Object
        },
        maxlength: {
            type: [Number, String],
            default: ''
        },
        limitReg: RegExp
    },
    computed: {
        limitInput() {
            if (this.limitReg) {
                return inputLimit(this.limitReg)
            } else {
                return inputLimit(inputSpaceLimitReg)
            }
        }
    },
    methods: {
        searchData(type) {
            this.$emit('searchData', this.value, type)
        },

        clear() {
            this.value = ''
            this.searchData('all')
            this.$emit('clear')
        }
    }
}
</script>

<style lang="scss" scoped>
    .is-focus {
        border-color: #009688 !important;
    }

    .search {
        display: flex;
        align-items: center;
        padding-left: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;

        .input-wrapper {
            flex: 1;
            padding-left: 0;
            margin-right: 6px;

            input {
                width: 100%;
                height: 36px;
                background: transparent;
                border: none;
                border-radius: 4px;
                font-size: 14px;
                color: #333;
                outline: none;

                &::placeholder {
                    color: #999;
                }

                &:focus {
                    border: none !important;
                }
            }
        }

        span {
            padding-left: 11px;
            padding-right: 10px;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #009688;
            border-left: 1px solid #ddd;
            white-space: nowrap;
            cursor: pointer;
        }

        .el-icon-close {
            width: 18.4px;
            height: 18.4px;
            line-height: 18.4px;
            margin-right: 8.6px;
            border-radius: 50%;
            background: #999;
            color: #fff;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
        }
    }
</style>
